import React from 'react';

export default function Spinner({ size = 8, className }) {
  const style        = { width: `${size}px`, height: `${size}px` };
  const spinnerClass = className ? `spinner ${className}` : 'spinner';

  return <div className={spinnerClass} style={style}/>;
}
